export function highlightFirstMatch(string, subString) {
  if (!string) return "";
  if (!subString) return string;
  const startIndex = string?.toLowerCase().indexOf(subString.toLowerCase());

  if (startIndex === -1) {
    return string;
  }

  const matched = string.substr(startIndex, subString.length);
  const highlightedString = (
    <>
      {string.substring(0, startIndex)}
      <span className="highlight-search-text">{matched}</span>
      {string.substring(startIndex + subString.length)}
    </>
  );

  return highlightedString;
}